

import React, { useState, useEffect, useRef } from "react";
import "./Login.css";
import image from "../../Assets/Images/Login/login.jpg";
import { FaUserShield } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { fetchApiData } from "../../Redux/features/Landing/landingSlice";
import { FULL_API_BASE_URL } from "../../Config/Config";
import { UAParser } from "ua-parser-js";

const Login = ({ setAuthenticated }) => {
  // -------------------- Device / Browser Info --------------------
  const [userInfo, setUserInfo] = useState({
    ipAddress: null,
    location: null,
    browser: null,
    operatingSystem: null,
    deviceType: null,
    screenResolution: null,
    isLoading: true,
    error: null,
  });

  const detectDeviceType = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isMobile =
      /android|webos|iphone|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        ua
      );
    const isTablet =
      /ipad|tablet|kindle/i.test(ua) ||
      (window.screen?.width >= 768 &&
        window.screen?.width <= 1024 &&
        /android/i.test(ua));
    if (isTablet) return "Tablet";
    if (isMobile) return "Mobile";
    return "Desktop";
  };

  const detectBrowser = () => {
    const parser = new UAParser(navigator.userAgent);
    const res = parser.getResult();
    const browserName = res.browser?.name || "Unknown";
    const browserVer = res.browser?.version || "";
    const osName = res.os?.name || "Unknown";
    const osVer = res.os?.version || "";
    return {
      browser: [browserName, browserVer].filter(Boolean).join(" "),
      os: [osName, osVer].filter(Boolean).join(" "),
      device: res.device?.type || "Desktop",
    };
  };

  const fetchIPInfo = async () => {
    const apis = [
      {
        url: "https://ipapi.co/json/",
        handler: (d) => ({
          ip: d.ip,
          location: `${d.city}, ${d.region}, ${d.country_name}`,
        }),
      },
      {
        url: "https://ip-api.com/json/",
        handler: (d) => ({
          ip: d.query,
          location: `${d.city}, ${d.regionName}, ${d.country}`,
        }),
      },
      {
        url: "https://ipinfo.io/json",
        handler: (d) => ({
          ip: d.ip,
          location: `${d.city}, ${d.region}, ${d.country}`,
        }),
      },
    ];
    for (const api of apis) {
      try {
        const r = await fetch(api.url);
        if (r.ok) {
          const data = await r.json();
          return api.handler(data);
        }
      } catch (_) {
        /* try next */
      }
    }
    return { ip: null, location: null };
  };

  useEffect(() => {
    (async () => {
      try {
        const [{ ip, location }, ua] = await Promise.all([
          fetchIPInfo(),
          Promise.resolve(detectBrowser()),
        ]);
        const device = detectDeviceType();

        setUserInfo({
          ipAddress: ip,
          location,
          browser: ua.browser,
          operatingSystem: ua.os,
          deviceType: ua.device !== "Desktop" ? ua.device : device,
          screenResolution: {
            width: window.screen?.width,
            height: window.screen?.height,
            devicePixelRatio: window.devicePixelRatio || 1,
          },
          isLoading: false,
          error: null,
        });
      } catch (err) {
        setUserInfo((p) => ({ ...p, isLoading: false, error: String(err) }));
      }
    })();
  }, []);

  // -------------------- Login & Reset States --------------------
  const dispatch = useDispatch();
  const passwordRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [inputState, setInputState] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [messageType, setMessageType] = useState("error");
  // Force Password Reset mode
  const [needsPasswordReset, setNeedsPasswordReset] = useState(false);
  const [resetNewPassword, setResetNewPassword] = useState("");
  const [resetConfirmPassword, setResetConfirmPassword] = useState("");
  const [resetContext, setResetContext] = useState({
    user_id: null,
    client_id: null,
    modified_by: "",
  });
  const [isResetting, setIsResetting] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  // -------------------- Handlers --------------------
  const handleRememberMeChange = (e) => setRememberMe(e.target.checked);

  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    setErrorMessage(
      "Please contact the System Administrator to reset your password."
    );
    setInputState(false);
  };

  const handleOAuthLogin = async () => {
    const oauthUsername = "siddharth";
    const oauthPassword = "siddharth123";
    try {
      const response = await fetch(`${FULL_API_BASE_URL}/token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          accept: "application/json",
        },
        body: new URLSearchParams({
          grant_type: "",
          username: oauthUsername,
          password: oauthPassword,
          scope: "",
          client_id: "",
          client_secret: "",
        }),
      });
      const data = await response.json();

      if (response.ok && data?.access_token) {
        localStorage.setItem("other", data.access_token);
        if (data.token_type)
          localStorage.setItem("other_type", data.token_type);
        if (data.expires_in)
          localStorage.setItem("other_expires_in", String(data.expires_in));
        return data.access_token;
      } else {
        setErrorMessage("OAuth2 authentication failed.");
        return null;
      }
    } catch (error) {
      setErrorMessage("An error occurred during OAuth2 authentication.");
      return null;
    }
  };

  // in case of login fail use this for developers for insta login VS
  // useEffect(() => {
  //   localStorage.setItem("clientId", "1");
  //   localStorage.setItem("clientBranchId", "1");
  //   localStorage.setItem("user_name", "dbose10");
  //   localStorage.setItem("userId", "4");
  //   localStorage.setItem("isLoggedIn", "true");
  // }, []);

  //   const handleLogin = async (e) => {
  //   e.preventDefault();

  //   if (!username || !password) {
  //     setErrorMessage("Fields are empty");
  //     setInputState(true);
  //     return;
  //   }

  //   setIsSubmitting(true);
  //     try {
  //     const res = await fetch(
  //       `${FULL_API_BASE_URL}/login?user_name=${encodeURIComponent(
  //         username
  //       )}&password=${encodeURIComponent(password)}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           accept: "application/json",
  //           "device-type": userInfo?.deviceType ?? "",
  //           "ip-address": userInfo?.ipAddress ?? "",
  //           "browser-name": userInfo?.browser ?? "",
  //         },
  //         body: "", // empty body as per curl
  //       }
  //     );

  //     const data = await res.json();

  //     // 🔴 IMPORTANT: handle forced-reset FIRST (works for 200 or 4xx status)
  //     if (data?.status === 403 && Number(data?.reset_password) === 1) {
  //       setNeedsPasswordReset(true);
  //       setResetContext({
  //         user_id: data?.user_id ?? null,
  //         client_id: data?.client_id ?? null,   // may be null on 403; backend should return it
  //         modified_by: username,
  //       });
  //       // Optional: carry over attempted password so user can reuse it
  //       setResetNewPassword("");
  //       setResetConfirmPassword("");
  //       setErrorMessage(
  //         data?.message ||
  //           "Your password must be reset before you can log in."
  //       );
  //       setInputState(false);
  //       return; // stop normal login flow
  //     }

  //     // ✅ Normal success path
  //     if (data?.status === 200 && /login/i.test(data?.message || "")) {
  //       setAuthenticated(true);
  //       const storage = rememberMe ? localStorage : sessionStorage;
  //       storage.setItem("isLoggedIn", "true");
  //       storage.setItem("userId", data.user_id);
  //       storage.setItem("clientId", data.client_id);

  //       dispatch(
  //         fetchApiData({
  //           userId: data.user_id,
  //           clientId: data.client_id,
  //           clientBranchId: data.client_branch_id,
  //         })
  //       );

  //       setInputState(false);
  //       setErrorMessage("");
  //     } else if (data?.status !== 403) {
  //       // ❌ Any other failure
  //       setErrorMessage(
  //         data?.message ||
  //           "Login Failed. Please check your username and password."
  //       );
  //       setInputState(true);
  //       setAuthenticated(false);
  //     }
  //   } catch (error) {
  //     console.error("Login Error:", error);
  //     setErrorMessage("An error occurred during login. Please try again.");
  //     setAuthenticated(false);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage("Fields are empty");
      setInputState(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const oauthToken = await handleOAuthLogin(); // no rememberMe

      const res = await fetch(
        `${FULL_API_BASE_URL}/login`,
          {
              method: "POST",
              headers: {
                  accept: "application/json",
                  "Content-Type": "application/json",
                  "device-type": userInfo?.deviceType ?? "",
                  "ip-address": userInfo?.ipAddress ?? "",
                  "browser-name": userInfo?.browser ?? "",
              },
              body: JSON.stringify({
                  user_name: username,
                  password: password,
              }),
          }
      );

      const data = await res.json();

      if (data?.status === 403 && Number(data?.reset_password) === 1) {
        setNeedsPasswordReset(true);
        setResetContext({
          user_id: data?.user_id ?? null,
          client_id: data?.client_id ?? null,
          modified_by: username,
        });
        setResetNewPassword("");
        setResetConfirmPassword("");
        setErrorMessage(
          data?.message || "Your password must be reset before you can log in."
        );
        setInputState(false);
        return;
      }

      if (data?.status === 200 && /login/i.test(data?.message || "")) {
        localStorage.setItem("isLoggedIn", "true");
        if (data.user_id != null)
          localStorage.setItem("userId", String(data.user_id));
        if (data.client_id != null)
          localStorage.setItem("clientId", String(data.client_id));
        if (data.client_branch_id != null)
          localStorage.setItem("clientBranchId", String(data.client_branch_id));

        // localStorage.setItem(
        //   "auth",
        //   JSON.stringify({
        //     token: oauthToken || localStorage.getItem("other") || null,
        //     user_id: data.user_id ?? null,
        //     client_id: data.client_id ?? null,
        //     client_branch_id: data.client_branch_id ?? null,
        //     login_time: Date.now(),
        //   })
        // );

        setAuthenticated(true);
        dispatch(
          fetchApiData({
            userId: data.user_id,
            clientId: data.client_id,
            clientBranchId: data.client_branch_id,
          })
        );

        setInputState(false);
        setErrorMessage("");
      } else if (data?.status !== 403) {
        setErrorMessage(
          data?.message ||
            "Login Failed. Please check your username and password."
        );
        setInputState(true);
        setAuthenticated(false);
      }
    } catch (error) {
      setErrorMessage("An error occurred during login. Please try again.");
      setAuthenticated(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateNewPassword = (password) => {
    if (!password) return "Password cannot be empty";
    if (password.length < 6)
      return "Password must be at least 6 characters long";
    if (!/[A-Z]/.test(password))
      return "Password must contain at least 1 uppercase letter";
    if (!/[a-z]/.test(password))
      return "Password must contain at least 1 lowercase letter";
    if (!/[0-9]/.test(password))
      return "Password must contain at least 1 number";
    if (!/[!@#$%^&*]/.test(password))
      return "Password must contain at least 1 special character (!@#$%^&*)";
    return null; // valid
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    const passwordError = validateNewPassword(resetNewPassword);
    if (passwordError) {
      setErrorMessage(passwordError);
      return;
    }

    if (resetNewPassword !== resetConfirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    setIsResetting(true);
    setErrorMessage("");

    try {
      const { user_id, client_id, modified_by } = resetContext;

      // const url = `${FULL_API_BASE_URL}/reset-new-password?user_id=${encodeURIComponent(
      //   user_id
      // )}&client_id=${encodeURIComponent(
      //   client_id
      // )}&new_password=${encodeURIComponent(
      //   resetNewPassword
      // )}&modified_by=${encodeURIComponent(modified_by || username)}`;

      // const res = await fetch(url, {
      //   method: "PUT",
      //   headers: { accept: "application/json" },
      // });

      const res = await fetch(
        `${FULL_API_BASE_URL}/reset-new-password`,
          {
              method: "PUT",
              headers: {
                  accept: "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  user_id: user_id,
                  client_id: client_id,
                  new_password: resetNewPassword,
                  modified_by: modified_by || username,
              }),
          }
      );

      const data = await res.json();

      if (data?.status === 200) {
        // Back to normal login mode
        setNeedsPasswordReset(false);
        // setPassword(resetNewPassword); // optionally prefill
        setUsername("");
        setPassword("");
        setResetNewPassword("");
        setResetConfirmPassword("");
        setMessageType("success");
        setErrorMessage("Password reset successful. Please log in.");
        // You can auto-login here if you want by calling handleLogin(...)
      } else {
        setErrorMessage(data?.message || "Password reset failed.");
      }
    } catch (err) {
      console.error("Reset Password Error:", err);
      setErrorMessage("An error occurred while resetting the password.");
    } finally {
      setIsResetting(false);
    }
  };

  // -------------------- Render --------------------
  return (
    <div className="loginPage lg-flex" style={{ flexDirection: "column" }}>
      <div className="lg-container lg-flex">
        <div className="videoDiv">
          <img src={image} alt="education" />
          <div className="textDiv">
            <h2 className="lg-title">
              <span style={{ fontWeight: "200" }}>Welcome to </span>
              <span className="lead-word">Coaching Buddy</span>
            </h2>
          </div>
        </div>

        <div className="formDiv lg-flex">
          <div className="lg-error">
            {errorMessage && (
              <div
                style={{
                  color: messageType === "error" ? "red" : "green",
                  marginTop: "10px",
                }}
              >
                {errorMessage}
              </div>
            )}
          </div>

          <form
            action=""
            className="form"
            onSubmit={needsPasswordReset ? handleResetPassword : handleLogin}
          >
            <div className="lg-input-containers-res grid">
              {/* Username */}
              <div className="inputDiv">
                <label htmlFor="username">Username</label>
                <div
                  className="lg-input lg-flex"
                  onClick={(e) => {
                    // Prevent focusing when clicking icons (eye icon etc.)
                    if (e.target.tagName !== "INPUT") {
                      const inputEl = e.currentTarget.querySelector("input");
                      inputEl?.focus();
                    }
                  }}
                  style={
                    inputState && !needsPasswordReset
                      ? { border: "1px solid red" }
                      : {}
                  }
                >
                  <FaUserShield className="iconav" style={{ color: "black" }} />
                  <input
                    type="text"
                    id="usernames"
                    placeholder="Enter Username"
                    value={username}
                    // onChange={(e) => {
                    //   setUsername(e.target.value);
                    //   if (inputState) setInputState(false);
                    // }}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const sanitized = raw
                        .toLowerCase()
                        .replace(/[^a-z0-9_]/g, "");
                      setUsername(sanitized);
                      if (inputState) setInputState(false);
                    }}
                    readOnly={needsPasswordReset}
                  />
                </div>
              </div>

              {/* Normal Login: Password */}
              {!needsPasswordReset && (
                // <div className="inputDiv">
                //   <label htmlFor="password">Password</label>
                //   <div
                //     className="lg-input lg-flex"
                //     style={inputState ? { border: "1px solid red" } : {}}
                //   >
                //     <RiLockPasswordFill className="iconav" style={{ color: "black" }} />
                //     <input
                //       type="password"
                //       id="password"
                //       placeholder="Enter Password"
                //       value={password}
                //       onChange={(e) => {
                //         setPassword(e.target.value);
                //         if (inputState) setInputState(false);
                //       }}
                //       className="hide-reveal"
                //     />
                //   </div>
                // </div>

                <div className="inputDiv">
                  <label htmlFor="password">Password</label>
                  <div
                    className="lg-input lg-flex"
                    style={inputState ? { border: "1px solid red" } : {}}
                    onClick={(e) => {
                      // Prevent focusing when clicking icons (eye icon etc.)
                      if (e.target.tagName !== "INPUT") {
                        const inputEl = e.currentTarget.querySelector("input");
                        inputEl?.focus();
                      }
                    }}
                  >
                    <RiLockPasswordFill
                      className="iconav"
                      style={{ color: "black" }}
                    />
                    <input
                      ref={passwordRef}
                      type={showPassword ? "text" : "password"} // toggle here
                      id="password"
                      placeholder="Enter Password"
                      value={password}
                      autoComplete="new-password"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        if (inputState) setInputState(false);
                      }}
                      className="hide-reveal"
                    />
                    <span
                      className="eye-icon"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer", marginLeft: "25px" }}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </span>
                  </div>
                </div>
              )}

              {/* Reset Mode: New Password + Confirm Password */}
              {needsPasswordReset && (
                <>
                  <div className="inputDiv">
                    <label htmlFor="new_password">New Password</label>
                    <div className="lg-input lg-flex">
                      <RiLockPasswordFill
                        className="iconav"
                        style={{ color: "black" }}
                      />
                      <input
                        type="password"
                        id="new_password"
                        placeholder="Enter New Password"
                        value={resetNewPassword}
                        onChange={(e) => setResetNewPassword(e.target.value)}
                        style={{ width: "250px" }}
                        className="hide-reveal"
                      />
                    </div>
                  </div>

                  {/* <div className="inputDiv">
                    <label htmlFor="confirm_password">Confirm Password</label>
                    <div className="lg-input lg-flex">
                      <RiLockPasswordFill className="iconav" style={{ color: "black" }} />
                      <input
                        type="password"
                        id="confirm_password"
                        placeholder="Confirm New Password"
                        value={resetConfirmPassword}
                        onChange={(e) => setResetConfirmPassword(e.target.value)}
                        className="hide-reveal" 
                      />
                    </div>
                  </div> */}
                  <div className="inputDiv">
                    <label htmlFor="confirm_password">Confirm Password</label>
                    <div
                      className="lg-input lg-flex"
                      style={inputState ? { border: "1px solid red" } : {}}
                    >
                      <RiLockPasswordFill
                        className="iconav"
                        style={{ color: "black" }}
                      />
                      <input
                        type={showPassword ? "text" : "password"} // toggle here
                        id="confirm_password"
                        placeholder="Confirm New Password"
                        value={resetConfirmPassword}
                        onChange={(e) =>
                          setResetConfirmPassword(e.target.value)
                        }
                        className="hide-reveal"
                      />
                      <span
                        className="eye-icon"
                        onClick={togglePasswordVisibility}
                        style={{ cursor: "pointer", marginLeft: "45px" }}
                      >
                        {showPassword ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </span>
                    </div>
                  </div>
                </>
              )}
              {/* Remember + Forgot (hidden in reset mode) */}
              {!needsPasswordReset && (
                <div className="forgotPassword">
                  <input
                    type="checkbox"
                    id="rememberMe"
                    name="rememberMe"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                  />
                  <label
                    className="logged-in"
                    htmlFor="rememberMe"
                    style={{ color: "rgb(66, 66, 66)", marginLeft: "5px" }}
                  >
                    Keep Me Logged In
                  </label>
                  <a
                    onClick={handleForgotPasswordClick}
                    style={{
                      marginLeft: "30px",
                      color: "#4933ff",
                      fontWeight: "600",
                    }}
                    className="password-forget"
                  >
                    Forgot Password?
                  </a>
                </div>
              )}
            </div>

            <button
              type="submit"
              className="lg-btn lg-flex"
              style={{
                marginTop: "50px",
                opacity: isSubmitting || isResetting ? 0.7 : 1,
                pointerEvents: isSubmitting || isResetting ? "none" : "auto",
              }}
              disabled={isSubmitting || isResetting}
            >
              {needsPasswordReset
                ? isResetting
                  ? "Resetting..."
                  : "Submit"
                : isSubmitting
                ? "Logging in..."
                : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;


